import React, { type ReactElement } from 'react'
import { Col, Container, Row } from 'react-bootstrap'

import Image from '@/components/image/image'
import Link from '@/components/link/link'
import { generateUrl } from '@/internal/utils/generate-url'

import * as styles from './header-person.module.scss'

const HeaderPerson = ({
  photo,
  firstName,
  secondName,
  job,
  expertise,
  about,
  linkedin
}: Readonly<Queries.GctPersonFragment>): ReactElement => {
  return (
    <header className={styles.header}>
      <Container>
        <Row>
          <Col xs={4} md={3}>
            <Image className={styles.image} image={photo} />
          </Col>
          <Col
            xs={8}
            md={9}
            className="pt-lg-5 ps-lg-5 pb-4 d-flex justify-content-center flex-column"
          >
            <div className="d-flex align-items-center flex-wrap">
              <h1>
                {firstName} {secondName}
              </h1>{' '}
              {about?.value === null &&
                linkedin !== null &&
                linkedin !== '' && (
                  <>
                    <span>/</span>
                    <a href={linkedin}>
                      <img
                        src="/media/linkedin-author-white.svg"
                        alt="linkedin profile"
                      />
                    </a>
                  </>
                )}
            </div>

            <div className={styles.position}>{job}</div>
            <div className={`${styles.expertise} d-flex flex-wrap`}>
              {expertise !== null && expertise.length > 0 && (
                <h3>Expert in:</h3>
              )}
              {expertise !== null &&
                expertise.length > 0 &&
                expertise.map((item, index) => {
                  return (
                    <span key={item?.slug}>
                      <Link
                        key={index}
                        to={
                          item?.slug != null
                            ? generateUrl(item?.__typename, item?.slug)
                            : ''
                        }
                      >
                        {item?.externalName}
                      </Link>
                      {index < expertise.length - 1 ? ',' : ''}
                    </span>
                  )
                })}
            </div>
          </Col>
        </Row>
      </Container>
    </header>
  )
}

export default HeaderPerson
